import React from 'react';
import Firebase from 'firebase';
import RenderComponents from './renderComponents';

export default class setDatasets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            element: this.props.element,
            dataset_id: this.props.element.table.dataset_name
        }
        this.setParams = this.setParams.bind(this);
        this.validator = this.validator.bind(this);
    }

    componentDidMount() {
        var datasetsRef = Firebase.database()
            .ref('datasets')
            .child(localStorage.client_id)
            .child("tablas");
        datasetsRef.on('value', snap => {
            this.setState({ datasets: snap.val() });
        })
    }

    setParams() {
        var name;
        Object.keys(this.state.datasets).map((d, index) => {
            if(d === this.state.dataset_id){
                name = Object.keys(Object.values(this.state.datasets)[index])[0] !== "modified_at" ? Object.keys(Object.values(this.state.datasets)[index])[0] : Object.keys(Object.values(this.state.datasets)[index])[1]
            }
        })
        var table = {
            dataset: this.state.dataset_id,
            dataset_name: name,
            col_id: this.state.col_id,
            col_name: this.state.col_name
        };
        this.props.callBack(table)
    }

    validator() {
        if (this.state.dataset_id && this.state.dataset_col && this.state.col_id && this.state.col_name) {
            return (
                <button onClick={(e) => { this.setParams() }} type="button" className="btn btn-outline-success">Guardar</button>
            )
        }
    }

    render() {
        return (
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="name">Datasets:</label>
                    <select className="form-control" id="ccmonth" onChange={(e) => {
                        this.setState({
                            dataset_id: Object.keys(this.state.datasets)[e.target.value],
                            dataset_col: Object.keys(Object.values(this.state.datasets)[e.target.value])[0] !== "modified_at" ? Object.values(Object.values(this.state.datasets)[e.target.value])[0] : Object.values(Object.values(this.state.datasets)[e.target.value])[1],
                        })
                    }}>
                        <option hidden>{this.props.element ? this.state.element.table.dataset_name : "Seleccione"}</option>
                        {
                            this.state.datasets ?
                                Object.values(this.state.datasets).map((d, index) => (
                                    <option key={index} value={index}>
                                        {Object.keys(d)[0] !== "modified_at" ? Object.keys(d)[0] : Object.keys(d)[1]}
                                    </option>
                                ))
                                :
                                <option>Cargando..</option>
                        }
                    </select>
                </div>
                {
                    this.state.dataset_col ?
                        <div className="form-group">
                            <label htmlFor="name">Columna Id:</label>
                            <select className="form-control" id="ccmonth" onChange={(e) => {
                                this.setState({ col_id: e.target.value })
                            }}>
                                <option value="columna id" hidden>{this.props.element.table.col_id ? this.props.element.table.col_id : "seleccione"}</option>
                                {
                                    this.state.dataset_col.map(id => (
                                        <option key={id} value={id}>
                                            {id}
                                        </option>
                                    ))
                                }
                            </select>
                            <label htmlFor="name">Columna Nombre:</label>
                            <select className="form-control" id="ccmonth" onChange={(e) => {
                                this.setState({ col_name: e.target.value })
                            }}>
                                <option value="columna valor" hidden>{this.props.element.table.col_name ? this.props.element.table.col_name : "Seleccione"}</option>
                                {
                                    this.state.dataset_col.map(name => (
                                        <option key={name} value={name}>
                                            {name}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>
                        :
                        ""
                }
                <div className="form-group">
                    {this.validator()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/forms/setDatasets.js